<template>
  <div class="section-category section-swipecard">
    <div class="col-10 col-md-5 mx-auto mt-5">
      <h2 class="text-uppercase text-center mb-4" v-translate >swipe card</h2>
      <div class="card">
        <div class="card-body pt-4">
          <div class="pt-3">
            <div class="form-group mb-3">
              <input class="form-control form-control-lg" placeholder="Input customer name" v-model="searchCust">
            </div>
            <ul class="dropdown-list">
              <li v-for="customer in filterCustomers" :key="customer.id" @click="pickCustomer(customer)">
                <span class="text-uppercase">{{ customer.name }}</span>
                <br>
                <span>000000000{{ customer.id }}</span>
              </li>
              <li class="no-results" v-if="searchCust && filterCustomers.length === 0" v-translate>No results found!</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState, mapGetters } from 'vuex';
import BillService from '@/services/BillService';

export default {
  name: 'SwipeCard',
  data() {
    return {
      searchCust: '',
    };
  },
  computed: {
    filterCustomers() {
      const search = this.searchCust.toLowerCase();
      return this
              .getArray('customers')
              .filter(({ name }) => name.toLowerCase().includes(search))
              .sort((a, b) => a.name.localeCompare(b.name));
    },
    ...mapState({
      bill: state => state.bill.bill,
    }),
    ...mapGetters(['updatedBillItems']),
  },
  methods: {
    pickCustomer(customer) {
      // post this customer to api
      if (this.bill.id !== '') {
        this.bill.customer = customer.id;
        const billData = Object.assign({}, this.bill, { billItems: this.updatedBillItems });
        BillService.post(billData);
      }
      this.$router.push({ name: 'order' });
    },
  },
  created() {
    if (!this.bill.id) {
      this.$router.push('order');
    }
  },
};
</script>

<style lang="scss" scoped>
  .active-users {
    font-size: 22px;
    .card-label {
      font-weight: 300;
      min-width: 120px;
      display:  inline-block;
    }
  }
  .dropdown-list {
    list-style: none;
    padding: 0;
    li {
      margin-bottom: .25rem;
      border: 1px solid #f7f7f7;
      padding: 5px 1rem;
      &:not(.no-results) {
        &:hover {
          background-color: #DAE7A4;
          cursor: pointer;
        }
      }
    }
  }
  .is-hidden-dropdown {
    display: none;
  }
</style>
